import Service from "./Service"

class CloudStorageFileService extends Service {

    update = (id, requestBody) => this.patch(`/cloud-storage-files/${id}`, requestBody)
}

const cloudStorageFileService = new CloudStorageFileService()
export default cloudStorageFileService